module.exports = __webpack_public_path__ + "img/ckdxcy.b509ce78.png";